"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseOtherFacilityCommitmentDto = instanceOfNurseOtherFacilityCommitmentDto;
exports.NurseOtherFacilityCommitmentDtoFromJSON = NurseOtherFacilityCommitmentDtoFromJSON;
exports.NurseOtherFacilityCommitmentDtoFromJSONTyped = NurseOtherFacilityCommitmentDtoFromJSONTyped;
exports.NurseOtherFacilityCommitmentDtoToJSON = NurseOtherFacilityCommitmentDtoToJSON;
exports.NurseOtherFacilityCommitmentDtoToJSONTyped = NurseOtherFacilityCommitmentDtoToJSONTyped;
/**
 * Check if a given object implements the NurseOtherFacilityCommitmentDto interface.
 */
function instanceOfNurseOtherFacilityCommitmentDto(value) {
    if (!('date' in value) || value['date'] === undefined)
        return false;
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    return true;
}
function NurseOtherFacilityCommitmentDtoFromJSON(json) {
    return NurseOtherFacilityCommitmentDtoFromJSONTyped(json, false);
}
function NurseOtherFacilityCommitmentDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'date': json['date'],
        'startTime': json['startTime'],
        'endTime': json['endTime'],
    };
}
function NurseOtherFacilityCommitmentDtoToJSON(json) {
    return NurseOtherFacilityCommitmentDtoToJSONTyped(json, false);
}
function NurseOtherFacilityCommitmentDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'date': value['date'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
    };
}
//# sourceMappingURL=NurseOtherFacilityCommitmentDto.js.map